import gql from 'graphql-tag'


export const ACTIVITIES = gql`
    query userActivities($userId: String) {
        userActivities(userId: $userId) {
            id
            type 
            user {
                id
                firstName
                lastName
                avatar
                profile {
                    nickName
                }
            }
            object {
                id
                objectName
                objectImg
                type
            }
            updatedAt
        }
    }
`